export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 1200 400">
          <path d="M0,200 Q300,100 600,200 T1200,200" stroke="currentColor" fill="none" strokeWidth="1"/>
          <path d="M0,220 Q300,120 600,220 T1200,220" stroke="currentColor" fill="none" strokeWidth="1"/>
          <circle cx="200" cy="150" r="3" fill="currentColor"/>
          <circle cx="600" cy="180" r="3" fill="currentColor"/>
          <circle cx="1000" cy="160" r="3" fill="currentColor"/>
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-5 gap-12 mb-12">
          <div className="md:col-span-2 space-y-6">
            <div className="flex items-center gap-2">
              <img 
                src="https://static.readdy.ai/image/fa99bb9c62df4d6cdaf96fd6599da80a/bf3e389d3d8583412aec99bb39af84bb.png" 
                alt="Prakash Electricals Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold" style={{ fontFamily: 'Georgia, serif' }}>
                PRAKASH ELECTRICALS [OPK]<span className="text-sky-500">.</span>
              </span>
            </div>

            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-transparent border border-gray-600 rounded-full text-sm outline-none focus:border-sky-500 transition-colors"
              />
              <button className="w-12 h-12 bg-sky-500 rounded-full flex items-center justify-center hover:bg-sky-600 transition-colors flex-shrink-0 cursor-pointer">
                <i className="ri-notification-line text-xl"></i>
              </button>
            </div>

            <div className="text-2xl leading-relaxed" style={{ fontFamily: 'Georgia, serif' }}>
              <div>Reliable Electrical Solutions</div>
              <div className="text-gray-400">For Every Project</div>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 tracking-wider">SERVICES</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-sky-400 transition-colors cursor-pointer">
                  Cable Laying
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-sky-400 transition-colors cursor-pointer">
                  Meter Installation
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-sky-400 transition-colors cursor-pointer">
                  Panel Work
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 tracking-wider">COMPANY</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li>
                <button onClick={() => scrollToSection('about')} className="hover:text-sky-400 transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="hover:text-sky-400 transition-colors cursor-pointer">
                  Our Team
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('projects')} className="hover:text-sky-400 transition-colors cursor-pointer">
                  Certifications
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 tracking-wider">SUPPORT</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-sky-400 transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="hover:text-sky-400 transition-colors cursor-pointer">
                  FAQ
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-sky-400 transition-colors cursor-pointer">
                  Safety Guidelines
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="text-xs text-gray-400">
              © 2025 Prakash Electricals. All rights reserved.
            </div>

            <div className="flex gap-4">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-gray-600 rounded-lg flex items-center justify-center hover:border-sky-500 hover:text-sky-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-gray-600 rounded-lg flex items-center justify-center hover:border-sky-500 hover:text-sky-500 transition-colors cursor-pointer">
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-gray-600 rounded-lg flex items-center justify-center hover:border-sky-500 hover:text-sky-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://WA.me/918851640119" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-gray-600 rounded-lg flex items-center justify-center hover:border-sky-500 hover:text-sky-500 transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>

            <div className="text-xs text-gray-400 flex gap-4">
              <a href="#" className="hover:text-sky-400 transition-colors cursor-pointer">Privacy Policy</a>
              <span>|</span>
              <a href="#" className="hover:text-sky-400 transition-colors cursor-pointer">Terms of Service</a>
              <span>|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-sky-400 transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
